module.exports = __webpack_public_path__ + "img/jojo.ca6b7def.jpg";